import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import RacingDetailContext from '../Context/RacingDetail.context';
import CompetitorsTable from '../CompetitorsTable/CompetitorsTable';
import RankCell from '../CompetitorsTable/CompetitorsTableRow/RankCell/RankCell';
import './FinishedRace.scss';

export default function FinishedRace({ evt, racingType } : any) {

  const [results, setResults] = useState(null);
  const [payouts, setPayouts] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [showMarket, setShowMarket] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { selectedMarket, setSelectedMarket, setPodiumNr, podiumNr } = useContext(RacingDetailContext);

  const loadData = async () => {
    const data = await dispatch.racing.getRaceInfo({ eventCode: evt });

    if (data && data?.event){
      setResults(data.event);
      setMarkets(data.markets);
      setPayouts(data.payouts);
      setPodiumNr(data?.payouts.length);
    }
  };

  useEffect(() => {
    if (results === null)
      loadData();

    if (results){
      setSelectedMarket(results.markets[0]);
    }

    if (payouts.length > 0 && showMarket === false) {
      for (const payout of payouts) {
        if (payout && payout['show']) {
          setShowMarket(true);
          break;
        }
      }
    }
  }, [evt, results, selectedMarket, setSelectedMarket, payouts]);

  const resultsTable = () => {
    return (
      _.map(payouts, (resultInfo, index) => {
        return (
          <tr key={ resultInfo.rank + resultInfo.name + index + resultInfo.winner } className="results__row results__rank">
            <RankCell value={ resultInfo.rank } podiumNr={ podiumNr } />
            <td className="results__number">
              <span className="results__starting-number">{ resultInfo.startingNumber }</span>
              <span className="results__name">{ resultInfo. name }</span>
            </td>
            <td className="results__win">{ resultInfo.winner }</td>
            <td className="results__sp">{ resultInfo.secondPlace }</td>
            { resultInfo?.show && <td className="results__show">{ resultInfo.show }</td> }
          </tr>
        );
      })
    );
  };

  const marketResults = () => {

    return (
      <div className="results__special-markets">
        {
          _.map(_.filter(markets, (market) => market.typeId !== 10100 && market.typeId !== 10300 && market.typeId !== 10200), (market, index) => {
            const rowCombinations =  [];

            _.map(market.combinations, (combination, index) => {
              if (index + 1 === market.combinations.length || market.combinations.length === 1) {
                rowCombinations.push(combination);
              } else {
                rowCombinations.push(combination + ', ');
              }
            });

            return (
              <div className="results__special-markets-row" key={ market.type + market.combinations + market.value + index }>
                <span className="results__type">{ market.type }</span>
                <div className="results__combination-box">
                  {
                    _.isArray(market.combinations) ?
                      <div className="results__combination">
                        { rowCombinations }
                      </div>
                      :
                      <div key={ index + market.combinations } className="results__combination">{ market.combinations }</div>
                  }
                </div>
                <span className="results__value">{ market.value }</span>
              </div>
            );
          })
        }
      </div>
    );
  };

  return (
    <div className="results">
      <span className="results__title">{ t('racingDetail.officialResults') }</span>
      <div className="results__container">
        <div className="results__markets-container">
          <table className="results__markets">
            <tbody>
              <tr>
                <th className="results__starting-number">{ t('raceDetail.rank') }</th>
                <th className="results__starting-number-header">{ t('raceDetail.runner') }</th>
                <th className="results__market-label">{ t('raceDetail.win') }</th>
                <th className="results__market-label">{ t('raceDetail.place') }</th>
                { showMarket && <th className="results__market-label">{ t('raceDetail.show') }</th> }
              </tr>
            </tbody>
            {
              payouts && payouts.length > 0 &&
                <tbody>
                  { resultsTable() }
                </tbody>
            }
          </table>
        </div>
        { marketResults() }
      </div>
      {
        results && selectedMarket && <CompetitorsTable
          key="CompetitorsTable-official"
          selectedEvent={ results }
          payouts={ payouts }
          maxMarkets={ 1 }
          racingType={ racingType }
        />
      }
    </div>
  );
}
